export const TECHNOLOGY_SETUP_COMMANDS: Record<string, Record<string, string>> = {
  npm: {
    Npm: 'npm install --registry {registry} {publishId}@{version}',
  },
  nuget: {
    '.Net CLI': 'dotnet add package -s {registry} {publishId} --version {version}',
  },
  maven: {
    'Apache Maven':
      '<dependency>\n\t<groupId>{mavenGroupId}</groupId>\n\t<artifactId>{mavenArtifactId}</artifactId>\n\t<version>{version}</version>\n</dependency>\n\n<!-- -------------- -->\n\n<repository>\n\t<id>graft-repository</id>\n\t<url>{registry}</url>\n</repository>',
  },
  pypi: {
    PyPi: 'python -m pip install --extra-index-url {registry} {publishId}=={version}',
  },
  packagist: {
    Composer: 'composer config repositories.graft composer {registry}\ncomposer require {publishId}:{version}',
  },
  ruby: {
    RubyGems: 'gem install {publishId} -v "{version}" --source "{registry}"',
  },
}
